// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 内容主推荐列表 GET /tj-recommend/content-team/list */
export async function tjRecommendContentTeamListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListTjRecommendContentTeamResp>('/tj-recommend/content-team/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 课程推荐列表 GET /tj-recommend/course-series/list */
export async function tjRecommendCourseSeriesListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListTjRecommendCourseSeriesResp>(
    '/tj-recommend/course-series/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 指标介绍列表 GET /tj-recommend/index/list */
export async function tjRecommendIndexListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListTjRecommendIndexResp>('/tj-recommend/index/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 直播推荐列表 GET /tj-recommend/live-room/list */
export async function tjRecommendLiveRoomListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListTjRecommendLiveRoomResp>('/tj-recommend/live-room/list', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 营销视频推荐列表 GET /tj-recommend/promotion-video/list */
export async function tjRecommendPromotionVideoListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.tjRecommendPromotionVideoListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListTjRecommendPromotionVideoResp>(
    '/tj-recommend/promotion-video/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 观点推荐列表 GET /tj-recommend/stream-message/list */
export async function tjRecommendStreamMessageListUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultListTjRecommendStreamMessageResp>(
    '/tj-recommend/stream-message/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}
